import React from 'react'
import CustomTable from '../../../elements/Table/CustomTable'
import { Button } from 'antd'
import { Link } from 'react-router-dom'
import { withRouter } from 'react-router-dom'
import StatusCell from '../../../elements/Table/Cells/StatusCell'
import OrganisationsSelect from '../../../elements/Select/Organistaions'
import { strVal } from '../../../modules/Utils'

function List(props) {
  const { list, fetch, fetching, onShow, company, onChangeCompany } = props

  const columns = [
    {
      Header: 'System ID',
      accessor: '_key',
      Cell: ({ value, original }) => (
        <Link
          to={{
            pathname: `/people/payrolls/${original._key}/update`,
          }}>
          {value}
        </Link>
      ),
    },
    { Header: 'Currency', accessor: 'currency' },
    { Header: 'Amount', accessor: 'amount' },
    {
      Header: 'Period',
      accessor: 'end',
      Cell: ({ value, original }) => `${strVal(original, 'start')} / ${value}`,
    },
    {
      Header: 'Company',
      accessor: 'company.fn',
      hideable: true,
      hideDefault: true,
    },
    { Header: 'Status', accessor: 'status', Cell: StatusCell },
  ]

  return (
    <CustomTable
      data={list}
      defaultPageSize={20}
      isFilterable={true}
      fetching={fetching}
      fetch={fetch}
      ExtraOptionsButtons={() => (
        <OrganisationsSelect
          value={company}
          onChange={onChangeCompany}
          placeholder={'Filter by a company'}
          size={'small'}
          style={{ width: '450px', paddingRight: 20, float: 'right' }}
        />
      )}
      CreateButton={() => (
        <Button
          type={'primary'}
          size="small"
          icon={'plus'}
          onClick={() => {
            props.history.push({
              pathname: '/people/payrolls/new',
            })
          }}>
          New
        </Button>
      )}
      columns={columns}
    />
  )
}

List.propTypes = {}
List.defaultProps = {}

export default withRouter(List)
